import ebsOverview from './overview.json';

import summaryEBSRegion from './widgets/summaryEBSRegion.json';
import summaryEBSInstanceType from './widgets/summaryEBSInstanceType.json';
import summaryEBSHealth from './widgets/summaryEBSHealth.json';
import summaryEBSOperatingState from './widgets/summaryEBSOperatingState.json';

import ebsPerformanceOverview from './widgets/performance/ebsPerformanceOverview.json';
import ebsPerformanceMaster from './widgets/performance/ebsPerformanceMaster.json';
import ebsPerformanceDetail from './widgets/performance/ebsPerformanceDetail.json';
import ebsPerformanceDetailTitle from './widgets/performance/ebsPerformanceDetailTitle.json';
import ebsEntityPerformanceIOPS from './widgets/performance/ebsEntityPerformanceIOPS.json';
import ebsEntityPerformanceThroughput from './widgets/performance/ebsEntityPerformanceThroughput.json';
import ebsEntityPerformanceTotalTime from './widgets/performance/ebsEntityPerformanceTotalTime.json';

import ebsLatencyOverview from './widgets/latency/ebsLatencyOverview.json';
import ebsLatencyMaster from './widgets/latency/ebsLatencyMaster.json';
import ebsLatencyDetail from './widgets/latency/ebsLatencyDetail.json';
import ebsLatencyDetailTitle from './widgets/latency/ebsLatencyDetailTitle.json';
import ebsEntityLatencyQueueLength from './widgets/latency/ebsEntityLatencyQueueLength.json';
import ebsEntityLatencyTotalTime from './widgets/latency/ebsEntityLatencyTotalTime.json';
import ebsEntityLatencyIdleTime from './widgets/latency/ebsEntityLatencyIdleTime.json';

import filterEBSOperatingState from './widgets/filterEBSOperatingState.json';
import filterEBSHealth from './widgets/filterEBSHealth.json';
import filterEBSRegion from './widgets/filterEBSRegion.json';
import filterEBSInstanceType from './widgets/filterEBSInstanceType.json';

export default [
  ebsOverview,

  // Filters
  filterEBSOperatingState,
  filterEBSHealth,
  filterEBSRegion,
  filterEBSInstanceType,

  // Widgets

  // summary
  summaryEBSRegion,
  summaryEBSInstanceType,
  summaryEBSHealth,
  summaryEBSOperatingState,

  // metrics
  ebsPerformanceOverview,
  ebsPerformanceMaster,
  ebsPerformanceDetail,
  ebsPerformanceDetailTitle,
  ebsEntityPerformanceIOPS,
  ebsEntityPerformanceThroughput,
  ebsEntityPerformanceTotalTime,

  ebsLatencyOverview,
  ebsLatencyMaster,
  ebsLatencyDetail,
  ebsLatencyDetailTitle,
  ebsEntityLatencyIdleTime,
  ebsEntityLatencyTotalTime,
  ebsEntityLatencyQueueLength,
];
